var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavMobilePin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.627 19.089"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nav-mobile-pin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 118",
    d: "M0 6.267h13.627v-19.089H0z",
    transform: "translate(0 12.822)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 218",
    clipPath: "url(#nav-mobile-pin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 117",
    d: "M12.958 12.275c0-1.749-1.322-3.41-2.734-3.41V3.4a1.376 1.376 0 001.369-1.365 1.376 1.376 0 00-1.369-1.37H3.401a1.375 1.375 0 00-1.365 1.37A1.375 1.375 0 003.401 3.4v5.465c-1.408 0-2.73 1.664-2.73 3.414a.687.687 0 00.682.683h4.309l.811 5.174a.342.342 0 00.341.287h.01a.343.343 0 00.331-.31l.545-5.151h4.575a.688.688 0 00.683-.687z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 4.28,
    strokeWidth: 0.9
  })))));
}

export default __webpack_public_path__ + "0fe682dffe76ad25977a011b016db5b3.svg";
export { SvgNavMobilePin as ReactComponent };